/*************************************************
 Handle Filters on wines page.
*************************************************/

jQuery(function ($) {

	if (!$('.filters-container').length) {
		return;
	}

	const is_desktop = window.innerWidth > 1024;

	// Show filter popup on filter click on mobile.
	$(document).on("click", ".wine-filter", function () {
		if (is_desktop) {
			$this = this;
			$(".wine-filter").each(function( index, el) {
				if (el === $this) return;
				$(this).parent().find(".filter-dropdown").hide();
			})
			$(this).parent().find(".filter-dropdown").toggle();
		} else {
			$("body").addClass("lock-scroll");
			$(this).parent().find(".mobile-filter-popup").addClass("modal-show");
		}
	});

	// Close popup on outside click.
	$(document).on("click", function(e) {
		if (!$(e.target).closest('.filter-dropdown').length && !$(e.target).hasClass('wine-filter')) {
			$(".filter-dropdown").hide();
		}
	})

	// Handle filter popup close.
	$(document).on("click", ".mobile-filter-popup .icon-close, .filter-show-result", function () {
		$(".mobile-filter-popup").removeClass("modal-show");
		$("body").removeClass("lock-scroll");
		do_filtering_action();
	});

	// Handle filters on mobile.
	$(document).on("click", ".filter-checkbox input", function () {
		const value = $(this).data("id");
		const label = $(this).next().text();
		const filter = $(this).closest(".mobile-filter-popup").data("filter");

		if ($(this).is(":checked")) {
			const filteringClass = ".filter-checkbox." + filter;
			const str = `<span class="filtering-category filtering-${filter}" data-filter="${filter}" data-id="${value}">${label}<span class="icon-close"></span></span>`;
			$(".filtering-category-container").append(str);
			$(".filtering-category .icon-close").on("click", function () {
				const value = $(this).parent().data("id");
				$(this).parent().remove();
				$(filteringClass).each(function () {
					if (value === $(this).find("input").data("id")) {
						$(this).find("input").prop("checked", false);
					}
				});
				do_filtering_action();
			});
		} else {
			$(`.filtering-category-container [data-id=${value}][data-filter=${filter}]`).remove();
		}
	});

	// Handle filters on desktop.
	$(document).on("click", ".filters-container li", function () {
		$(this).toggleClass("selected");

		const value = $(this).data("id");
		const filter = $(this).closest(".filter-dropdown").data("filter");
		if ($(this).hasClass("selected")) {
			const label = $(this).text();
			str = `<span class="filtering-category filtering-${filter}" data-filter="${filter}" data-id="${value}">${label}<span class="icon-close"></span></span>`;
			$(".filtering-category-container").append(str);
		} else {
			$(`.filtering-category-container [data-id=${value}][data-filter=${filter}]`).remove();
		}

		$(".filter-dropdown").hide();
		do_filtering_action();
	});

	// Handle Price Range sliders.
	const min = parseInt($('#rangeSlider').data('min')) || 0;
	const max = parseInt($('#rangeSlider').data('max')) || 200;

	const resetSilders = () => {
		$("#rangeSlider").slider("values", 0, $("#rangeSlider").data("min"));
		$("#rangeSlider").slider("values", 1, $("#rangeSlider").data("max"));
		$("#rangeSlider-mobile").slider("values", 0, $("#rangeSlider-mobile").data("min"));
		$("#rangeSlider-mobile").slider("values", 1, $("#rangeSlider-mobile").data("max"));
	}

	$(document).on("click", ".filtering-price .icon-close", function () {
		$(this).parent().remove();
		resetSilders();
		do_filtering_action();
	});

	const onUpdateSlider = ([min, max]) => {
		const str = `<span class="filtering-category filtering-price" data-low="${min}" data-upper="${max}">$${min} - $${max}<span class="icon-close"></span></span>`;
		$(".filtering-price").remove();
		$(".filtering-category-container").append(str);
		do_filtering_action();
	}

	const sliderOptions = {
		range: true,
		min: min,
		max: max,
		values: [min, max],
		slide: function (e, ui) {
			$(e.target).next().html(`$${ui.values[0]} - $${ui.values[1]}`);
		},
		stop: function (event, ui) {
			onUpdateSlider(ui.values)
		},
	};

	if ($('#rangeSlider').length) {
		$("#rangeSlider").slider(sliderOptions);
		$("#rangeSlider-mobile").slider(sliderOptions);
	}

	// Handle on close button click of selected filters.
	$(document).on("click", ".filtering-category .icon-close", function () {
		const value = $(this).parent().data("id");
		$(this).parent().remove();
		$(".type-varietal-category").each(function () {
			if (value === $(this).data("id")) {
				$(this).removeClass("selected");
			}
		});
		$(".vintage-category").each(function () {
			if (value === $(this).data("id")) {
				$(this).removeClass("selected");
			}
		});
		do_filtering_action();
	});

	// Clear all filters.
	$(document).on("click", ".clear-filter", function () {
		// Desktop Selectors.
		$(".filtering-category").each(function () {
			const value = $(this).data("id");
			$(`.filtering-category li[data-id="${value}"]`).removeClass('selected');
			$(this).remove();
		});

		// Mobile Selectors.
		$(".filter-checkbox input").each(function () {
			$(this).prop("checked", false);
		});

		// Reset Sliders.
		resetSilders();

		do_filtering_action();
	});

	// Do filtering action.
	function do_filtering_action() {
		const type_ids = [];
		const varietal_ids = [];
		const vintage_ids = [];
		const filtering_price = [];

		$(".clear-filter").css("display", $(".filtering-category").length ? "flex" : "none");

		if ($(".filtering-category").length) {
			$(".wine-card").hide();
			$(".shop-banner").hide();
			$(".shop-banner-mobile").hide();
			$(".no-result").css('display', 'none');
		} else {
			$(".wine-card").show();
			$(".shop-banner").show();
			$(".shop-banner-mobile").show();
		}

		if ($(".filtering-price").length) {
			filtering_price.push($(".filtering-price").data("low"));
			filtering_price.push($(".filtering-price").data("upper"));
		}

		$(".filtering-varietal").each(function () {
			varietal_ids.push($(this).data("id"));
		});
		$(".filtering-type").each(function () {
			type_ids.push($(this).data("id"));
		});
		$(".filtering-vintage").each(function () {
			vintage_ids.push($(this).data("id"));
		});

		let filtered_wines = 0;
		$("#category-post-content .wine-card")
			.not(".gift-card")
			.each(function () {
				const varietal = $(this).data("varietal");
				const type = $(this).data("type");
				const vintage = $(this).data("vintage");
				const price = $(this).data("price");

				if (varietal_ids.length && !varietal_ids.includes(varietal)) {
					$(this).hide();
					return;
				}
				if (type_ids.length && !type_ids.includes(type)) {
					$(this).hide();
					return;
				}
				if (vintage_ids.length && !vintage_ids.includes(vintage)) {
					$(this).hide();
					return;
				}
				if (
					filtering_price.length &&
					(filtering_price[0] > price || filtering_price[1] < price)
				) {
					$(this).hide();
					return;
				}
				$(this).show();
				filtered_wines++;
			});

		if (!filtered_wines) {
			$(".no-result").css('display', 'flex');
		}
	}
});
